import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import makeStyles from "@mui/styles/makeStyles";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import UnauthorizedCard from "./UnAuthorizedCard";
import SuccessCard from "./SuccessCard";
import SessionTimer from "./SessionTimer";

import { validateSecurePayment } from "../_redux/actions/paymentActions";

const useStyles = makeStyles((theme) => ({
  toolbar: theme.mixins.toolbar,
  content: { maxWidth: 1250, margin: "auto" },
  logo: { width: 140, height: 28 },
}));

function SecurePayPage({ validateSecurePayment }) {
  const classes = useStyles();
  const { t } = useTranslation();
  const { token } = useParams();
  const [validateSecurePaymentData, setValidateSecurePaymentData] =
    useState(null);
  const [isExpired, setIsExpired] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  useEffect(() => {
    const params = { token: token.toString() };
    validateSecurePayment(params)
      .then((response) => {
        setValidateSecurePaymentData({ ...response });
      })
      .catch(() => setIsExpired(true));
  }, [token]);

  return (
    <div className={classes.content}>
      <div className={classes.toolbar} />
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
        padding="20px"
      >
        <Grid item>
          <Grid container direction="column">
            <Grid item>
              <img
                className={classes.logo}
                src={"./src/_images/LogoLimited.png"}
                alt="LifeSafer"
              />
            </Grid>
            <Grid item>
              <Typography
                style={{
                  fontSize: 18,
                  fontWeight: 500,
                  textAlign: "center",
                  color: "#1c355e",
                }}
              >
                {t("securepay.title")}
              </Typography>
            </Grid>
          </Grid>
        </Grid>

        {isExpired ? (
          <Grid item>
            <UnauthorizedCard />
          </Grid>
        ) : isSuccess ? (
          <SuccessCard amountDue={validateSecurePaymentData.amountDue} />
        ) : validateSecurePaymentData ? (
          <SessionTimer
            setIsExpired={setIsExpired}
            validateSecurePaymentData={validateSecurePaymentData}
            setIsSuccess={setIsSuccess}
          />
        ) : null}
      </Grid>
    </div>
  );
}

SecurePayPage.propTypes = {
  validateSecurePayment: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  validateSecurePayment,
};

export default connect(null, mapDispatchToProps)(SecurePayPage);
